<template>
    <with-dimensions>
        <table-ish slot-scope="{ width }">
            <table-ish-row-header>
                <table-ish-cell>
                    Fee
                </table-ish-cell>
                <table-ish-cell
                    v-if="width > 500"
                    :shrink="true"
                />
                <table-ish-cell
                    class="text-right"
                    :shrink="true"
                >
                    Balance
                </table-ish-cell>
            </table-ish-row-header>
            <table-ish-row-router-link
                v-for="fee in fees"
                :key="fee.uuid"
                :to="{
                    name: $router.fix('dashboard.*.fees.show'),
                    params: {
                        fee: fee.uuid
                    }
                }"
            >
                <table-ish-cell>
                    <truncate-hack>
                        {{ fee.title }}
                    </truncate-hack>

                    <with-variables
                        slot="secondary"
                        :variables="{ fee }"
                    >
                        <truncate-hack slot-scope="{ fee: { tenancy } }">
                            Due {{ fee.due_at | moment('D MMM, YYYY') }}

                            <template v-if="tenancy && tenancy.property && tenancy.property.address">
                                for {{ $gate.role('landlord') ? tenancy.property.name : tenancy.property.address.name }}
                            </template>
                        </truncate-hack>
                    </with-variables>
                </table-ish-cell>
                <table-ish-cell
                    v-if="width > 500"
                    :shrink="true"
                    class="text-right"
                >
                    <span
                        :class="punctualStateCss(fee.punctual_state)"
                        class="px-3 py-1 text-sm font-semibold rounded-full"
                    >
                        {{ $t(`fee.punctual_state.${fee.punctual_state}`) }}
                    </span>
                </table-ish-cell>
                <table-ish-cell
                    :shrink="true"
                    class="text-right"
                >
                    {{ fee.remaining | money }}

                    <template
                        slot="secondary"
                    >
                        <span
                            v-if="width < 500"
                            :class="punctualStateCss(fee.punctual_state)"
                            class="px-2 text-xs font-semibold leading-none rounded-full"
                        >
                            {{ $t(`fee.punctual_state.${fee.punctual_state}`) }}
                        </span>

                        <template v-else>
                            of {{ fee.amount | money(0) }}
                        </template>
                    </template>
                </table-ish-cell>
            </table-ish-row-router-link>
        </table-ish>
    </with-dimensions>
</template>

<script>
    import StateCssMixin from '../mixins/state-css'

    export default {
        mixins: [
            StateCssMixin
        ],
        props: {
            fees: {
                type: Array,
                required: true
            }
        }
    }
</script>
